<template>
  <AuthLayout :mode="mode">
    <Section
      v-if="searchResults.length === 0"
      heading="Member Mailer"
      :mode="mode"
    />
    <div
      v-if="searchResults.length === 0"
      class="rounded-xl p-10 sm:p-6"
      :class="[
        mode === 'dark' ? 'bg-dark-sidebar' : 'bg-white-100 shadow-primary',
      ]"
    >
      <div class="grid gap-4">
        <div class="grid grid-cols-3 gap-3 sm:grid-cols-1 sm:gap-4">
          <AppInput
            :mode="mode"
            id="company"
            title="Company"
            placeholder="Company"
            v-model="contactSearch.company_name"
          />
          <AppInput
            :mode="mode"
            id="first-name"
            title="First name"
            placeholder="First name"
            v-model="contactSearch.first_name"
          />
          <AppInput
            :mode="mode"
            id="last-name"
            title="Last name"
            placeholder="Last name"
            v-model="contactSearch.last_name"
          />
        </div>
        <div
          class="grid grid-cols-4 gap-3 md:grid-cols-2 sm:grid-cols-1 sm:gap-4"
        >
          <AppSelect
            :mode="mode"
            title="Country"
            v-model="contactSearch.country"
          >
            <template #options>
              <option value="">Country</option>
              <option
                v-for="(country, key) in countries"
                :value="country.country"
                :key="key"
              >
                {{ country.country }}
              </option>
            </template>
          </AppSelect>
          <AppInput
            :mode="mode"
            v-if="cities.length === 0"
            id="city"
            title="City"
            placeholder="City"
            v-model="contactSearch.city"
          />
          <AppSelect
            v-else
            :mode="mode"
            title="City"
            v-model="contactSearch.city"
          >
            <template #options>
              <option value="">City</option>
              <option
                v-for="(city, key) in cities"
                :value="city.name"
                :key="key"
              >
                {{ city.name }}
              </option>
            </template>
          </AppSelect>
          <AppInput
            :mode="mode"
            v-if="states.length === 0"
            id="state"
            title="State"
            placeholder="State"
            v-model="contactSearch.state"
          />
          <AppSelect
            v-else
            :mode="mode"
            title="State"
            v-model="contactSearch.state"
          >
            <template #options>
              <option value="">State</option>
              <option
                v-for="(state, key) in states"
                :value="state.code"
                :key="key"
              >
                {{ state.name }}
              </option>
            </template>
          </AppSelect>
          <AppInput
            :mode="mode"
            id="zip"
            title="Zip"
            placeholder="Zip"
            v-model="zip"
          />
        </div>
        <div class="grid grid-cols-3 gap-3 sm:grid-cols-1 sm:gap-4">
          <AppInput
            :mode="mode"
            id="email"
            type="email"
            title="Email"
            placeholder="Email"
            v-model="contactSearch.email"
          />
          
          <AppSelect
            :mode="mode"
            title="Board Member"
            v-model="contactSearch.is_board_member"
          >
            <template #options>
              <option value="" selected>Board Member</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </template>
          </AppSelect>
          
          <AppSelect
            :mode="mode"
            title="Primary contact"
            v-model="contactSearch.primary_contact"
          >
            <template #options>
              <option value="" selected>Primary contact</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </template>
          </AppSelect>
        </div>
        <div class="grid grid-cols-3 gap-3 sm:grid-cols-1 sm:gap-4">
          <AppSelect
            :mode="mode"
            title="Billing contact"
            v-model="contactSearch.billing_contact"
          >
            <template #options>
              <option value="" selected>Billing contact</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </template>
          </AppSelect>
          <AppSelect
            :mode="mode"
            title="Administrator"
            v-model="contactSearch.administrator"
          >
            <template #options>
              <option value="" selected>Administrator</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </template>
          </AppSelect>
          <AppSelect
            :mode="mode"
            title="Rec leads"
            v-model="contactSearch.rec_leads"
          >
            <template #options>
              <option value="" selected>Rec leads</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </template>
          </AppSelect>
        </div>
        <div
          class="grid grid-cols-4 gap-3 md:grid-cols-2 sm:grid-cols-1 sm:gap-4"
        >
          <AppSelect
            :mode="mode"
            title="Rec news letter"
            v-model="contactSearch.rec_news_letter"
          >
            <template #options>
              <option value="" selected>Rec news letter</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </template>
          </AppSelect>
          <AppSelect
            :mode="mode"
            title="Unpaid dues"
            v-model="contactSearch.unpaid_dues"
          >
            <template #options>
              <option value="" selected>Unpaid dues</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </template>
          </AppSelect>
          <AppSelect
            :mode="mode"
            title="Subscriber"
            v-model="contactSearch.network_subscriber">
            <template #options>
              <option value="" selected>Both</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </template>
          </AppSelect>
          <AppSelect
            :mode="mode"
            title="Member"
            v-model="contactSearch.assoc_member">
            <template #options>
              <option value="" selected>Both</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </template>
          </AppSelect>
          
          
        </div>
        <div class="flex">
          <AppCheckbox
            :mode="mode"
            v-model="contactSearch.technical_services"
            id="tech-service"
            title="Tech service company (Select to request a tech service quote or assistance from a member)"
            classes="checkbox-long"
          />
        </div>
        <div class="mt-2">
          <DealerFor
            :mode="mode"
            :mfrs="manufactuers"
            @selectedMfrsUpdated="updateSelectedMfrs"
          />
        </div>
        <div class="mt-2">
          <AppButton title="Search" @action="search" />
        </div>
      </div>
    </div>
    <SearchResults
      v-else
      :data="searchResults"
      :contact="contact"
      :member="member"
      :countries="countries"
      :mode="mode"
    />
  </AuthLayout>
</template>

<script>
import Section from "@C/Common/Section.vue";
import SearchResults from "@C/SearchResults.vue";
import ApiRequest from "@L/ApiRequest";
import { useGlobalErrorHandler } from "@L/errorHandler";
import { useUserStore } from "@S/user";
import { useToastStore } from "@S/toast";
import { useLoaderStore } from "@S/loader";
import { useCountriesStore } from "@S/countries";
import AppLabel from "@C/Form/AppLabel.vue";
import DealerFor from "@C/Searches/DealerFor.vue";
import AuthLayout from "@A/AuthLayout.vue";
import AppCheckbox from "@C/Form/AppCheckbox.vue";
import AppSelect from "@C/Form/AppSelect.vue";
import AppInput from "@C/Form/AppInput.vue";
import AppButton from "@C/Common/AppButton.vue";

export default {
  name: "MemberMailer",
  components: {
    AuthLayout,
    Section,
    SearchResults,
    AppLabel,
    DealerFor,
    AppCheckbox,
    AppSelect,
    AppInput,
    AppButton,
  },
  setup() {
    const userStore = useUserStore();
    const toastStore = useToastStore();
    const loaderStore = useLoaderStore();
    const countriesStore = useCountriesStore();
    const { handleError } = useGlobalErrorHandler();
    return {
      userStore,
      toastStore,
      loaderStore,
      countriesStore,
      handleError,
    };
  },
  props: {
    mode: String,
  },
  data() {
    return {
      states: [],
      cities: [],
      zip: "",
      debounceTimer: null,
      contactSearch: {
        first_name: "",
        last_name: "",
        city: "",
        state: "",
        country: "",
        company_name: "",
        member_id: "",
        network_subscriber: "",
        assoc_member: "",
        mfr_company: "",
        email: "",
        board_type: "",
        is_board_member: "",
        primary_contact: "",
        billing_contact: "",
        administrator: "",
        rec_leads: "",
        rec_news_letter: "",
        unpaid_dues: "",
        technical_services: false,
      },
      searchResults: [],
      selectedMfrs: [],
      manufactuers: [],
    };
  },
  created() {
    if (!this.isAdmin) {
      this.toastStore.show(
        "You do not have permission to see this page",
        "error",
      );
      this.$router.push({ name: "home" });
      return;
    }
  },
  mounted() {
    this.getMfrs();
  },
  methods: {
    async getMfrs() {
      this.loaderStore.setIsLoading(true);
      try {
        const { data } = await ApiRequest().get(`/mfr_summary`);
        if (data) {
          this.manufactuers = data
            .filter(
              (item) => item.mfr.company && item.mfr.company.trim() !== "",
            )
            .sort((a, b) => a.mfr.company.localeCompare(b.mfr.company));
        }
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loaderStore.setIsLoading(false);
      }
    },
    async search() {
      this.loaderStore.setIsLoading(true);
      const payload = this.buildSearchPayload();
      try {
        const { data } = await ApiRequest().post(`/contact_search`, payload);
        if (!data) {
          this.toastStore.show("No data found", "info");
          return;
        }
        this.searchResults = data;
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loaderStore.setIsLoading(false);
      }
    },
    async getLocations() {
      if (!this.contactSearch.country || !this.zip) {
        this.states = [];
        this.cities = [];
        return;
      }
      try {
        const payload = {
          country_code: this.$getCountryCode(
            this.countries,
            this.contactSearch.country,
          ),
          postal_code: this.zip,
        };
        const response = await fetch("/public_api/postal_codes", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
        if (!response.ok) {
          this.toastStore.show("Failed to fetch location data", "error");
          return;
        }
        const data = await response.json();
        if (!data) {
          this.toastStore.show("No location data found", "error");
          this.states = [];
          this.cities = [];
          return;
        }
        const statesMap = new Map();
        const citiesMap = new Map();
        data.forEach((item) => {
          const source = item._source;
          if (source.admin_code1) {
            statesMap.set(source.admin_code1, {
              code: source.admin_code1,
              name: source.admin_name1 || source.admin_code1,
            });
          }
          if (source.place_name) {
            citiesMap.set(source.place_name, {
              name: source.place_name,
            });
          }
        });
        this.states = Array.from(statesMap.values());
        this.cities = Array.from(citiesMap.values());
      } catch (e) {
        this.handleError(e);
        this.states = [];
        this.cities = [];
      }
    },
    debouncedGetLocations() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.getLocations();
      }, 500);
    },
    buildSearchPayload() {
      const payload = { ...this.contactSearch };
      const stringFields = [
        "first_name",
        "last_name",
        "company_name",
        "country",
        "city",
        "state",
        "email",
        "board_type",
        "member_id",
      ];
      const booleanFields = [
        "primary_contact",
        "billing_contact",
        "administrator",
        "rec_leads",
        "rec_news_letter",
        "unpaid_dues",
        "network_subscriber",
        "assoc_member",
        "technical_services",
        "is_board_member"
      ];
      stringFields.forEach((field) => {
        if (!payload[field]) {
          delete payload[field];
        }
      });
      booleanFields.forEach((field) => {
        if (payload[field] === "") {
          delete payload[field];
        } else if (typeof payload[field] === "string") {
          payload[field] = payload[field] === "true";
        }
      });
      if (this.selectedMfrs?.length === 0) {
        delete payload.mfr_company;
      } else if (this.selectedMfrs?.length > 0) {
        payload.mfr_company = this.selectedMfrs.join(",");
      }
      return payload;
    },
    updateSelectedMfrs(data) {
      this.selectedMfrs = data;
    },
  },
  computed: {
    loggedInUser() {
      return this.userStore.user;
    },
    contact() {
      return this.loggedInUser.contact;
    },
    member() {
      return this.loggedInUser.member;
    },
    countries() {
      return this.countriesStore.countries;
    },
    isAdmin() {
      return this.loggedInUser.global_admin;
    },
  },
  watch: {
    "contactSearch.country": function (newVal) {
      if (newVal && this.zip) {
        this.debouncedGetLocations();
      }
    },
    zip: function (newVal) {
      if (newVal && this.contactSearch.country) {
        this.debouncedGetLocations();
      }
    },
  },
};
</script>
